import { Segment } from '@dna/analytics'

document.addEventListener('DOMContentLoaded', () => {
  const $yotpoUgcGalleries = document.querySelectorAll('[id*="yotpo_product_reviews_vugc_media_gallery"]')

  if ($yotpoUgcGalleries.length) {
    for (const $gallery of $yotpoUgcGalleries) {
      $gallery.addEventListener('click', (event) => {
        const $galleryItem = event.target.closest('.vugc-card-container')
        const $galleryItemCta = event.target.closest('.yotpo-lightbox-product-button')
        const $galleryItemProduct = event.target.closest('.yotpo-vugc-lightbox-item .tagged-product-card')

        if ($galleryItem) {
          // @segment
          Segment.protect(() => {
            Segment.track(Segment.CONSTANTS.EVENTS.UGC_POST_CLICKED)
          })
        }
        if ($galleryItemCta) {
          // @segment
          Segment.protect(() => {
            const $galleryItemProductContent = $galleryItemCta.closest('.yotpo-lightbox-product-details-text')
            const $galleryItemProductTitle = $galleryItemProductContent?.querySelector('h4')
            const productTitle = $galleryItemProductTitle?.textContent

            Segment.track(Segment.CONSTANTS.EVENTS.UGC_POST_PRODUCT_ADDED, {
              ugc_post_product_name: productTitle
            })
          })
        }
        
        if ($galleryItemProduct) {
          // @segment
          Segment.protect(() => {
            Segment.track(Segment.CONSTANTS.EVENTS.UGC_POST_PRODUCT_CLICKED)
          })
        }
      })
    }
  }
})